module.exports = {
  GRADE_TYPES: {
    PERCENTAGE: 'percentage',
    FREE_FORM: 'freeform',
    RUBRIC: 'rubric',
    PASS_FAIL: 'passFail',
    LETTER_GRADE: 'letterGrade',
    POINTS: 'points',
  },
  PASS_FAIL_ITEMS: {
    pass: 'Pass',
    fail: 'Fail',
  },
  LETTER_GRADES: [
    'A+',
    'A',
    'A−',
    'B+',
    'B',
    'B−',
    'C+',
    'C',
    'C-',
    'D+',
    'D',
    'D-',
    'PASS',
    'E',
    'F',
  ],
};
